module.exports = __webpack_public_path__ + "img/forgot-password.288e5347.svg";